import {Chip} from "@mui/material";
import {useContext} from "react";
import {EditHardwareItem} from "./HwEditingContextProvider";
import {HardwareViewModeContext} from "../../quote/hardware/HardwareViewMode";

export function SupplierChip(props: {
    value: EditHardwareItem;
    alwaysShow?: boolean;
}) {
    const showByUsSuppliers = useContext(HardwareViewModeContext).showByUsSuppliers;

    // by-others items always show their supplier; by-us categories are hidden
    // unless the "By-Us" toggle is on (or the group is being edited).
    const byOthers = props.value.customerSupplied === true;
    if (!byOthers && !showByUsSuppliers && !props.alwaysShow) return null;

    const name = props.value.supplierCategoryName;
    if (!name) return null;

    const {bg, fg} = colorFor(name);

    return (
        <Chip
            label={name}
            size="small"
            style={{
                height: 16,
                fontSize: 10,
                marginRight: 4,
                backgroundColor: bg,
                color: fg,
            }}
        />
    );
}

function colorFor(name: string) {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = (hash * 31 + name.charCodeAt(i)) | 0;
    }
    const hue = Math.abs(hash) % 360;
    return {
        bg: `hsl(${hue}, 70%, 85%)`,
        fg: `hsl(${hue}, 60%, 25%)`,
    };
}
